module.exports = __webpack_public_path__ + "img/cp-TERAS-LEGACY-SLIDE-CAREER-PREVIEW-pdf.3075e521.jpeg";